import lazyframe from "lazyframe";

lazyframe('.lazyframe');
